import axios from 'axios'
import OSS from 'ali-oss'
// 获取上传阿里权限
const getAliAuth = () => {
  return axios.get('/code-api/bigFileUpload')
}
// 获取年月日
const getYearMonthDate = ()=> {
  const dateTime = new Date()
  const Y = dateTime.getFullYear()
  const M = ((dateTime.getMonth() + 1) + '').padStart(2,'0')
  const D = (dateTime.getDate() + '').padStart(2,'0')
  return `${Y}${M}${D}`
}
// 上传阿里方法
async function commonUpLoad  (file, eventName='AuthrealName') {
  const {data:authData} = await getAliAuth()
  const {code, data,message} = authData
  if (code !== 200) return this.$toast(message)
  // 实例化OSS
  let client = new OSS({
    region: data.region, // 'oss-cn-huhehaote',
    accessKeyId: data.accessKeyId,
    accessKeySecret: data.accessKeySecret,
    stsToken: data.securityToken,
    bucket: data.policy // 'hangxintong-file-upload'
  })
   // 设置文件名
   const fileName =
   'H5RealName' +
   eventName +
   '/' +
   getYearMonthDate() +
   '/' +
   new Date().getTime() +
   '.' +
   file.name
   let tempCheckpoint
   const _this = this
  return client.multipartUpload(fileName, file, 
    {
      progress(p, checkpoint) {
        // 上传进度条
        _this.$store.commit('login/setPercentage', +(p * 100 + '').slice(0,3))
        tempCheckpoint = checkpoint;
    },
    meta: {
      xid: 'H5',
      filename: encodeURI(file.name)
    },
    // mime: 'text/plain'
  }).then(res => {
    _this.$store.commit('login/setPercentage',0)
    const {name} = res
    if (!name) return this.$toast('上传失败')
    if ((location.host === 'wx94e10c25c5f1ef61.mp.dev.hangxintong.cn') || (location.host === 'wechat.hangxintong.cn')) {
      return Promise.resolve(`https://oss.hangxintong.cn/${name}`)
    } else {

      return Promise.resolve(`http://oss.dev.hangxintong.cn/${name}`)
    }
    
  })
  
}

export default commonUpLoad


// WEBPACK FOOTER //
// ./src/utils/commonUpLoad.js